class ShahrukhCartGoal extends HTMLElement {
  constructor() {
    super();
    this.goal = parseFloat(this.dataset.goal) || 60; // configurable
    this.currency = this.dataset.currency || '€';
    this.confettiShown = false;
  }

    connectedCallback() {
    this.render();
    this.loadCart();

    // Listen to DOM-based cart updates
    document.body.addEventListener('cart:updated', (e) => {
        if (e.detail && e.detail.cart) this.update(e.detail.cart);
    });

    // Listen to Minimog’s internal event bus
    if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
        window.MinimogEvents.subscribe(
        window.MinimogTheme.pubSubEvents.cartUpdate,
        (e) => this.update(e.cart)
        );
    }
    }

  async loadCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    this.update(cart);
  }

update(cart) {
  // Safety check: if cart is invalid or missing total_price, fetch it manually
  if (!cart || typeof cart.total_price === 'undefined' || isNaN(cart.total_price)) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(validCart => this.update(validCart))
      .catch(() => console.warn('Failed to refresh cart for ShahrukhCartGoal.'));
    return;
  }

  const total = cart.total_price / 100;
  const remaining = Math.max(this.goal - total, 0);
  const progress = Math.min((total / this.goal) * 100, 100).toFixed(2);
  const isGoalReached = remaining <= 0;

  const container = this.querySelector('.shahrukh-cartgoal');
  container.style.setProperty('--progress', `${progress}%`);
  const title = this.querySelector('.shahrukh-cartgoal__title');
  const icon = this.querySelector('.shahrukh-cartgoal__icon');

  if (isGoalReached) {
    title.innerHTML = `Congrats! You are eligible for <strong>FREE Shipping</strong>`;
    container.classList.add('shahrukh-cartgoal--done');
    icon.innerHTML = this.doneIcon();
    if (!this.confettiShown) {
      this.showConfetti();
      this.confettiShown = true;
    }
  } else {
    title.innerHTML = `Buy <strong>${this.currency}${remaining.toFixed(2)}</strong> more to enjoy <strong>FREE Shipping</strong>`;
    container.classList.remove('shahrukh-cartgoal--done');
    icon.innerHTML = this.defaultIcon();
    this.confettiShown = false;
  }
}

  render() {
    this.innerHTML = `
      <div class="shahrukh-cartgoal" style="--progress:0%">
        <h4 class="shahrukh-cartgoal__title">Loading...</h4>
        <div class="shahrukh-cartgoal__inner">
          <div class="shahrukh-cartgoal__bar">
            <span data-progress="0"></span>
          </div>
          <span class="shahrukh-cartgoal__icon">${this.defaultIcon()}</span>
        </div>
      </div>
    `;
  }

  defaultIcon() {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 12 12"><path d="M5.564.762c.129-.258.337-.387.623-.387s.494.129.623.387l1.396 2.836 3.137.473c.286.029.472.179.558.451.086.272.029.508-.172.709L9.453 7.443l.537 3.137a.687.687 0 0 1-.988.709L6.188 9.828l-2.814 1.461a.687.687 0 0 1-.988-.709l.537-3.137L.645 5.23a.687.687 0 0 1 .559-1.162l3.136-.473L5.564.762z"/></svg>`;
  }

  doneIcon() {
    return this.defaultIcon(); // same star; turns green via CSS
  }

  showConfetti() {
    const container = this.closest('.m-cart-drawer__inner') || document.body;
    const confettiContainer = document.createElement('div');
    confettiContainer.className = 'confetti-container';
    container.appendChild(confettiContainer);

    const colors = ['#EF2964','#00C09D','#2D87B0','#48485E','#EFFF1D'];
    const animations = ['slow','medium','fast'];
    let count = 0;

    const interval = setInterval(() => {
      count++;
      if (count >= 160) {
        clearInterval(interval);
        setTimeout(() => confettiContainer.remove(), 1500);
      }
      const confetti = document.createElement('div');
      const size = `${Math.floor(Math.random() * 4) + 7}px`;
      confetti.className = `confetti confetti--animation-${animations[Math.floor(Math.random() * 3)]}`;
      confetti.style.background = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.left = `${Math.floor(Math.random() * container.offsetWidth)}px`;
      confetti.style.width = size;
      confetti.style.height = size;
      confettiContainer.appendChild(confetti);
      setTimeout(() => confetti.remove(), 3000);
    }, 20);
  }
}

customElements.define('shahrukh-cart-goal', ShahrukhCartGoal);
